module.exports = __webpack_public_path__ + "static/img/穿墙保温.ea5dda44.jpeg";